import React, {useEffect, useState} from 'react'
import {Text, Transformer} from "react-konva";
import WebFontLoader from "webfontloader";

const TextShape = ({shapeProps, isSelected, onSelect, onChange}) => {
    const shapeRef = React.useRef();
    const trRef = React.useRef();
    const [refreshShape, setRefreshShape] = useState(false);
    // const [fontLoaded, setFontLoaded] = useState(false);

    useEffect(() => {
        if ((isSelected) && trRef.current) {
            // we need to attach transformer manually
            // @ts-ignore
            trRef.current.nodes([shapeRef.current]);
            // @ts-ignore
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);

    return (
        <>

            <Text
                onClick={(e) => {
                    // @ts-ignore
                    console.log('e.target: ', e.target);
                    // @ts-ignore
                    onSelect({
                        ...shapeProps,
                        // fontFamily: fontLoaded ? shapeProps?.fontFamily : "Arial",
                        x: e.target.x(),
                        y: e.target.y(),
                        width: e.target.width(),
                        height: e.target.height()
                    });
                }}
                /*onMouseEnter={(e) => {
                    // @ts-ignore
                    console.log('onMouseEnter() => e.target: ', e.target.getFontSize());
                    onSelect({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                        width: e.target.width(),
                        height: e.target.height()
                    });
                    // setRefreshShape(true);
                }}*/
                ref={shapeRef}
                {...shapeProps}
                // fontFamily={fontLoaded ? shapeProps?.fontFamily : "Arial"}
                draggable
                onDragEnd={(e) => {
                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                        width: e.target.width(),
                        height: e.target.height(),
                    });
                }}
                onTransformEnd={(e) => {
                    const node = shapeRef.current || undefined;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    const fontSize = node.fontSize();

                    node.scaleX(1);
                    node.scaleY(1);
                    // node.fontSize(1);
                    onChange({
                        ...shapeProps,
                        // fontFamily: fontLoaded ? shapeProps?.fontFamily : "Arial",
                        x: node.x(),
                        y: node.y(),
                        rotation: node.rotation(),
                        width: Math.max(5, (node.width() * scaleX) + 10),
                        height: Math.max((node.height() * scaleY) + 10),
                        fontSize: Math.max(node.fontSize() * scaleX)
                    });
                }}
            />

            {(isSelected) && (
                <Transformer
                    ref={trRef}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}

        </>
    )
}

export default TextShape
